module.exports = __webpack_public_path__ + "src/assets/img/bullet-crossing.ec9c3395.svg";